module.exports = __webpack_public_path__ + "static/img/steps.3b4bddaa.png";